import './UnitDisplay.css';
import React, {Component} from 'react';
import ChampionImage from '../utils/ChampionImage';
import ItemImage from '../utils/ItemImage';
import moment from 'moment'
import 'moment/locale/fr'
import items from '../../assets/json/tftitems.json';
moment.locale('fr');


class MatchsUnitDisplay extends Component{

    returnStar(tier) {
        let myReturn = [];
        for (var i = 0; i < tier; i++) {
            myReturn.push(
            <svg key={i} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="yellow bi bi-star-fill" viewBox="0 0 16 16">
                <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
            </svg>)
        }
        return myReturn;
    }

    returnGradient(pos) {
        switch (pos) {
            case 1:
                //return "[#e4b849]"
                return "yellow-500"
            case 2:
                return "[#00ff00]"
            case 3:
                return "green-500"
            case 4:
                return "[#ff0000]"
            case 8: 
                return "[#d19c9c]"
            default:
                return ""
        }
    }
    getSetNumber(name) {
        return name.split('_')[0].split('Set')[1]
    }

    getAugmentPath(augment) {
        //augment = TFT6_Augment_PortableForge
        //image name = portableforge2.tft_set6.png
        let name = augment.split('_')[2];
        let set = augment.split('_')[0];
        let setNumber = set.split("TFT")[1];
        return name.toLowerCase()+".tft_set"+setNumber+".png"
    }
    getName(unit) {
        if(unit.character_id.split('_')[1] === "TrainerDragon") {
            return "Nomsy"
        } else {
            return unit.character_id.split('_')[1]
        }
    }
    convertImageToRaw(itemName) {
        let temp = items.find((item) => item.nameId === itemName)
        if(temp !== undefined) {
            return temp.loadoutsIcon.replace("/lol-game-data/assets/ASSETS/","https://raw.communitydragon.org/latest/game/assets/").toLocaleLowerCase()
        } else {
            return itemName;
        }
    }
    render() {
        if(this.props.units != null && this.props.traits != null)
        {
            return(
                <div className={`boxDetailMatch rounded-lg border bg-white border-1 border-slate-700 mb-2 divide-y shadow-lg bg-gradient-to-r top${this.props.matches[this.props.index].placement} from-${this.returnGradient(this.props.matches[this.props.index].placement)}`}>
                    <div className='flex justify-between p-1'>
                        <div className='flex justify-start text-xs leading-8'>{moment(this.props.matches[this.props.index].datetime).locale('fr').fromNow()}
                        
                        {this.props.augments[this.props.index].map((augment,index) => (
                                <div key={augment} className='flex justify-start ml-1'>
                                    <div className={`text-center hexagon hexagon-augment self-center`} title={items.find((item) => item.nameId === augment).name}>
                                        <div className={`self-center augment ${augment}`} style={{marginLeft: '2px',marginTop: '-3px'}}>
                                            <img className='mt-[2px] ml-[3px] rounded-full ' style={{width: '22px',height: '22px',}} src={this.convertImageToRaw(augment)} alt={augment.split('_')[2]}/>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='flex flex-wrap'>
                            {this.props.traits[this.props.index].map((trait,index) => (
                                    trait.style !== 0 ? 
                                    <div key={index} className='flex'>
                                        <div className={`text-center hexagon hexagon-style${trait.style}`}>
                                            <div className={`synergy ${trait.name.split('_')[1]}`}>
                                                <img style={{filter: 'brightness(0)'}} src={`/traits/trait_icon_${this.getSetNumber(trait.name)}_${trait.name.split('_')[1].toLowerCase()}.png`} alt={trait.name.split('_')[1]}/>
                                            </div>
                                        </div>
                                        <div className='align-middle font-bold mr-2' style={{ lineHeight: '29px' }}>{trait.num_units}</div>
                                    </div>
                                    : ''                   
                            ))}
                        </div>
                    </div>
                                                    
                    <div className='flex justify-between  content-end  grid-champion px-2 pt-2'>
                        <div className='text-2xl align-middle' style={{width:'50px'}}>
                            {this.props.matches[this.props.index].placement}
                        </div>
                        <div className='flex flex-wrap'>
                            {this.props.units.map((unit,index) => (
                                <div key={index} style={{position:'relative'}} className='ml-3'>
                                    <div className={`rarity${unit.rarity} rarity rounded-full`}>
                                        <ChampionImage name={unit.character_id}/>
                                    </div>
                                    <div className={`flex justify-center box-star`}>
                                        {this.returnStar(unit.tier)}
                                    </div>
                                    <div className={`flex justify-center box-items`}>
                                        {unit.items.map((item,index) => (
                                            <ItemImage key={index} name={item} />
                                        ))}
                                    </div>
                                    <div className='text-sm flex justify-center' style={{width:'53px'}}>
                                        {this.getName(unit)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )       
        } else {
            <div className="flex justify-center justify-items-stretch">
                <div className="w-16 h-16 border-b-2 border-white-900 rounded-full animate-spin"></div>
			</div>
        }
        
    }
}
export default MatchsUnitDisplay